import { useActionsCellColumnBase } from '../ActionsCell';
import {
  TableColumn as WSRTableColumn,
  TableColumn as TableColumnWSR,
} from '@wix/design-system/dist/types/Table';
import React, { useMemo } from 'react';
import { NestedTableKeyedItem, NestedTableNestedModeState } from '../../state';
import { NestedTableActionsCell } from './NestedTableActionsCell';
import { NestedTableFlatModeState } from '../../state/NestedTableState/NestedTableFlatModeState';
import { NestedTableFlatKeyedItem } from '../../state/NestedTableState/NestedTableFlatModeSectionState';

export interface UseNestedTableActionsCellParams {
  state: NestedTableNestedModeState | NestedTableFlatModeState;
  actionsCellWidth?: string | number;
  actionsCellProps?: Partial<Omit<TableColumnWSR, 'render' | 'style'>>;
}

export function useNestedTableActionsCell<
  A extends
    | NestedTableKeyedItem<any, any, any>
    | NestedTableFlatKeyedItem<any, any, any>,
>(params: UseNestedTableActionsCellParams): WSRTableColumn<A> | null {
  const { state, actionsCellProps, actionsCellWidth } = params;

  const baseColumn = useActionsCellColumnBase({
    actionsCellProps,
    actionsCellWidth,
  });

  return useMemo(() => {
    const isActionsColumnRequired = state.levels.some(
      (level) => level.actionsCell,
    );

    if (!isActionsColumnRequired) {
      return null;
    }

    return {
      ...baseColumn,
      render: (keyedItem, rowNum) => {
        if (keyedItem.item.originalKeyedItem) {
          return (
            <NestedTableActionsCell
              state={keyedItem.item.state}
              item={keyedItem.item.originalKeyedItem}
              rowNum={rowNum}
            />
          );
        }
        return null;
      },
    };
  }, [baseColumn, state]);
}
